import CheckmarkBoxIcon from "../../../../assets/svg/checkmark-box.svg?react";

export const CheckmarkBox = () => {
  return <CheckmarkBoxIcon />;
};
